// extracted by mini-css-extract-plugin
module.exports = {"primary":"button_primary__pNpDl","secondary":"button_secondary__0zg5Z","button":"button_button__Wuoeg"};